export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput {
    'readCapacityUnits';
    'writeCapacityUnits';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.attributeTypeMap;
    }
    constructor() {
    }
}
